module.exports = __webpack_public_path__ + "assets/media/logo-row.8ee7278b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/logo-row.jpg
// module id = 3243
// module chunks = 0